import { render, staticRenderFns } from "./InstallmentInformationDetail.vue?vue&type=template&id=2a64e16b&scoped=true"
import script from "./InstallmentInformationDetail.vue?vue&type=script&lang=js"
export * from "./InstallmentInformationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a64e16b",
  null
  
)

export default component.exports